import { render, staticRenderFns } from "./MovementDetailModal.vue?vue&type=template&id=24801248&"
import script from "./MovementDetailModal.vue?vue&type=script&lang=js&"
export * from "./MovementDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports